import { apiClient } from './client'

/* ═══════════════════════════════════════════
   Contractors API (CRUD + sync)
   ═══════════════════════════════════════════ */

export interface Contractor {
  id: string
  name: string
  unp: string
  address?: string
  phone?: string
  email?: string
  note?: string
  created_at?: string
  updated_at?: string
}

export interface CreateContractorDto {
  name: string
  unp: string
  address?: string
  phone?: string
  email?: string
  note?: string
}

export type UpdateContractorDto = Partial<CreateContractorDto>

export const contractorsApi = {
  getAll: (q?: string) =>
    apiClient.get<{ contractors: Contractor[]; total: number }>('/api/contractors', {
      params: q ? { q } : undefined,
    }),

  getById: (id: string) =>
    apiClient.get<Contractor>(`/api/contractors/${id}`),

  create: (data: CreateContractorDto) =>
    apiClient.post<Contractor>('/api/contractors', data),

  update: (id: string, data: UpdateContractorDto) =>
    apiClient.put<Contractor>(`/api/contractors/${id}`, data),

  delete: (id: string) =>
    apiClient.delete(`/api/contractors/${id}`),
}
